import { EnhancedSleeveInfo } from '@blk/aw-api-clients';
import { EntityDisplay } from '@blk/aw-bff-typescript-models';
import { Security } from '@blk/awt-aladdinportfoliobuilderserver';
import { get } from 'lodash';

export type EntitiesDisplay = { [index: string]: EntityDisplay };

// Get the last value from a dot-separated path string eg: metadata.account.NAME => NAME, sectors.account.aw_classI.equity => equity
export const getLastValueFromPath = (colTag: string): string => colTag.split('.').at(-1) ?? '';

export const getTextLabelsForAggId = (entityDisplay: EntitiesDisplay | undefined, entity: string = ''): EntityDisplay =>
  get(entityDisplay, entity, { plural: '', singular: '', searchable: true } as EntityDisplay);

const CurrencyCusips = {
  AED: 'XAED00009',
  AFN: 'XAFN00006',
  ALL: 'XALL00003',
  AMD: 'XAMD00000',
  ANG: 'XANG00002',
  AOA: 'XAOA00004',
  ARS: 'XARS00002',
  ATS: 'XATS00000',
  AUD: 'XAUD00001',
  AWG: 'XAWG00002',
  AZN: 'XAZN00004',
  BAM: 'XBAM00001',
  BBD: 'XBBD00000',
  BDT: 'XBDT00003',
  BEF: 'XBEF00002',
  BGN: 'XBGN00003',
  BHD: 'XBHD00004',
  BIF: 'XBIF00008',
  BMD: 'XBMD00008',
  BND: 'XBND00007',
  BOB: 'XBOB00000',
  BRL: 'XBRL00005',
  BSD: 'XBSD00002',
  BTN: 'XBTN00009',
  BWP: 'XBWP00000',
  BYN: 'XBYN00003',
  BZD: 'XBZD00004',
  CAD: 'XCAD00009',
  CDF: 'XCDF00001',
  CHF: 'XCHF00007',
  CLF: 'XCLF00002',
  CLP: 'XCLP00000',
  CNH: 'XCNH00006',
  CNY: 'XCNY00009',
  COP: 'XCOP00007',
  COU: 'XCOU00006',
  CRC: 'XCRC00003',
  CUP: 'XCUP00000',
  CYP: 'XCYP00006',
  CZK: 'XCZK00006',
  DEM: 'XDEM00003',
  DKK: 'XDKK00000',
  DOP: 'XDOP00005',
  DZD: 'XDZD00000',
  ECS: 'XECS00000',
  EEK: 'XEEK00005',
  EGP: 'XEGP00002',
  ESP: 'XESP00009',
  ETB: 'XETB00009',
  EUR: 'XEUR00002',
  FIM: 'XFIM00004',
  FJD: 'XFJD00003',
  FRF: 'XFRF00009',
  GBP: 'XGBP00002',
  GEL: 'XGEL00008',
  GHS: 'XGHS00000',
  GIP: 'XGIP00005',
  GMD: 'XGMD00007',
  GNF: 'XGNF00001',
  GRD: 'XGRD00002',
  GTQ: 'XGTQ00001',
  GYD: 'XGYD00004',
  HKD: 'XHKD00007',
  HNL: 'XHNL00006',
  HRK: 'XHRK00004',
  HTG: 'XHTG00001',
  HUF: 'XHUF00001',
  IDR: 'XIDR00002',
  IEP: 'XIEP00005',
  ILS: 'XILS00001',
  INR: 'XINR00001',
  IQD: 'XIQD00009',
  IRR: 'XIRR00007',
  ISK: 'XISK00001',
  ITL: 'XITL00008',
  JMD: 'XJMD00001',
  JOD: 'XJOD00009',
  JPY: 'XJPY00002',
  KES: 'XKES00004',
  KGS: 'XKGS00002',
  KHR: 'XKHR00003',
  KMF: 'XKMF00003',
  KRW: 'XKRW00001',
  KWD: 'XKWD00007',
  KYD: 'XKYD00005',
  KZT: 'XKZT00009',
  LBP: 'XLBP00001',
  LKR: 'XLKR00007',
  LRD: 'XLRD00001',
  LSL: 'XLSL00002',
  LTL: 'XLTL00001',
  LUF: 'XLUF00002',
  LVL: 'XLVL00000',
  MAD: 'XMAD00007',
  MDL: 'XMDL00006',
  MGA: 'XMGA00007',
  MKD: 'XMKD00006',
  MMK: 'XMMK00008',
  MNT: 'XMNT00008',
  MOP: 'XMOP00005',
  MRO: 'XMRO00005',
  MTL: 'XMTL00009',
  MUR: 'XMUR00004',
  MVR: 'XMVR00003',
  MWK: 'XMWK00007',
  MXN: 'XMXN00000',
  MXV: 'XMXV00002',
  MYR: 'XMYR00000',
  MZN: 'XMZN00008',
  NAD: 'XNAD00005',
  NGN: 'XNGN00007',
  NIO: 'XNIO00003',
  NLG: 'XNLG00006',
  NOK: 'XNOK00004',
  NPR: 'XNPR00008',
  NZD: 'XNZD00008',
  OMR: 'XOMR00009',
  PAB: 'XPAB00004',
  PEN: 'XPEN00004',
  PGK: 'XPGK00008',
  PHP: 'XPHP00006',
  PKR: 'XPKR00008',
  PLN: 'XPLN00006',
  PTE: 'XPTE00008',
  PYG: 'XPYG00007',
  QAR: 'XQAR00007',
  RON: 'XRON00009',
  RSD: 'XRSD00007',
  RUB: 'XRUB00008',
  RWF: 'XRWF00007',
  SAR: 'XSAR00003',
  SBD: 'XSBD00003',
  SCR: 'XSCR00001',
  SEK: 'XSEK00004',
  SGD: 'XSGD00008',
  SKK: 'XSKK00007',
  SLL: 'XSLL00004',
  SRD: 'XSRD00006',
  SSP: 'XSSP00008',
  STD: 'XSTD00004',
  SVC: 'XSVC00003',
  SYP: 'XSYP00001',
  SZL: 'XSZL00009',
  THB: 'XTHB00009',
  TND: 'XTND00008',
  TOP: 'XTOP00000',
  TRY: 'XTRY00008',
  TTD: 'XTTD00002',
  TWD: 'XTWD00008',
  TZS: 'XTZS00002',
  UAH: 'XUAH00000',
  UGX: 'XUGX00009',
  USD: 'XUSD00000',
  UYU: 'XUYU00005',
  UZS: 'XUZS00009',
  VEF: 'XVEF00008',
  VND: 'XVND00003',
  VUV: 'XVUV00005',
  WST: 'XWST00001',
  XAF: 'XXAF00008',
  XAU: 'XXAU00005',
  XCD: 'XXCD00001',
  XDR: 'XXDR00009',
  XOF: 'XXOF00003',
  XPF: 'XXPF00002',
  YER: 'XYER00006',
  ZAR: 'XZAR00007',
  ZMW: 'XZMW00003',
  ZWD: 'XZWD00004',
  ZWR: 'XZWR00003',
};

export const getCashCusip = (currency: string): string => {
  if (CurrencyCusips.hasOwnProperty(currency)) {
    return CurrencyCusips[currency as keyof typeof CurrencyCusips];
  }
  throw Error(`Invalid currency: "${currency}"`);
};

export const getCusipSet = (securities: Security[]) => new Set(securities.map((security) => security.cusip));

export const getSleeveIdSet = (sleeves: EnhancedSleeveInfo[]) => new Set(sleeves.map((sleeve) => sleeve.id));

export const typedTruthyFilter = Boolean as unknown as <T>(x: T | false | undefined | null | '' | 0) => x is T;

interface WaitForReturnType {
  promise: () => Promise<unknown>;
  timeoutId: number | null;
}

export const waitForTime = (waitTimeInMs: number): WaitForReturnType => {
  let timeoutId: number | null = null;
  const promise = () =>
    new Promise((resolve) => {
      timeoutId = window.setTimeout(resolve, waitTimeInMs);
    });
  return {
    promise,
    timeoutId,
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Alias for unknown objects that are generically typed as object
export type AnyObject = { [key: string]: any };
export type UnknownObject = { [field: string]: unknown };

export type NonEmptyArray<T> = [T, ...T[]];
